import { render, staticRenderFns } from "./MegaMenu.vue?vue&type=template&id=aa6e798a"
import script from "./MegaMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MegaMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MegaMenu.vue?vue&type=style&index=0&id=aa6e798a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports